import { BreedVm, CountryVm } from '../api';
import { Place } from '../shared/models/model/concretes/shared/place.model';

export type DeclarationState = {
  name: string;
  addressAutocomplete: Place | null;
  address: string | null;
  postalCode: string | null;
  city: string | null;
  country: CountryVm | null;
  type: string;
  race: BreedVm | null;
  sexe: string;
  birth_date: string | Date | null;
  chip_tatoo: boolean | null;
  identification: string;
  vaccines: boolean | null;
  medical_history: string;
  diseaces: string[];
  cover_level: boolean | null;
  effect_date: string | Date | null;
};

export const initialDeclarationState: DeclarationState = {
  name: '',
  addressAutocomplete: null,
  address: null,
  postalCode: null,
  city: null,
  country: null,
  type: '',
  race: null,
  sexe: '',
  birth_date: null,
  chip_tatoo: null,
  identification: '',
  vaccines: null,
  medical_history: '',
  diseaces: [],
  cover_level: null,
  effect_date: null
};
